import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Auth, consumeReturnTo } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallbackPage() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    // Ex.: #session_id=abc123
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : "";
    if (!session_id) {
      setError("Sessão Google inválida.");
      setTimeout(() => nav("/login", { replace: true }), 1800);
      return;
    }
    (async () => {
      try {
        await Auth.session(session_id);
        // limpa o hash
        window.history.replaceState(null, "", "/auth/callback");
        await refresh();
        toast.success("Bem-vindo ao MIO");
        nav(consumeReturnTo(), { replace: true });
      } catch (e) {
        console.error(e);
        setError(e?.response?.status === 403 && e.response.data?.detail
          ? e.response.data.detail
          : "Não foi possível confirmar a sessão.");
        setTimeout(() => nav("/login", { replace: true }), e?.response?.status === 403 ? 5000 : 1800);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-display text-3xl text-slate-50 tracking-[0.22em]">MIO</div>
        <p className="text-slate-400 text-sm mt-4">{error || "A preparar a tua sessão…"}</p>
      </div>
    </div>
  );
}
